const React = require("react");
const _ = require("lodash");
const LoginStore = require("../../stores/LoginStore");
const defaultMessages = require("../../i18n/messages/default");
const { Input } = require("metro-ui-components");
const UrlUtils = require("../../utils/urlUtils");

class ShowPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginError: false,
      type: "password",
      score: "null",
      focussed: false,
      password: "",
      isCapsLockActive: false,
    };
    this.showHide = this.showHide.bind(this);
    this.setRef = this.setRef.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.verifyCapsLock = this.verifyCapsLock.bind(this);
    this._onLoginChange = this._onLoginChange.bind(this);
  }

  componentDidMount() {
    LoginStore.addLoginChangeListener(this._onLoginChange);
  }

  componentWillReceiveProps(prevProps) {
    this.props.focusInput !== prevProps.focusInput ? this.ref.focus() : null
  }

  _onLoginChange() {
    const isClientPasswordless = UrlUtils.getParameterByName("passwordless") === 'true';
    let appState = LoginStore.getState();

    if (appState.AuthCode.result != "Authenticated" && !isClientPasswordless) {
      this.setState({ loginError: appState.AuthCode.message ? true : false });
    }
  }

  showHide() {
    this.setState({
      type: this.state.type === "text" ? "password" : "text",
    });
  }

  setRef(ref) {
    this.ref = ref;
  }

  onPasswordChange(e, password) {
    this.setState({ password });
    this.props.onPasswordChange(password);
  }

  verifyCapsLock(event){
    let capsLockValue = event.getModifierState("CapsLock");
    this.setState({ isCapsLockActive: capsLockValue  });
  }

  renderSideBySidePasswordLabel() {
    if(this.props.onLinkClick) {
      return {
        link: this.props.forgotPasswordLinkUrl,
        onLinkClick: this.props.onLinkClick
      }
    }  
    return {}
  }

  render() {
    const extraProps = this.renderSideBySidePasswordLabel();
    let capsLockErrorMessage = this.state.isCapsLockActive ? this.props.intl.formatMessage(defaultMessages["passwordCapsLockActive"]) : "";
    return (
      <div id="input_container">
        <div className="password-field">
          <Input
            inputRef={this.setRef}
            id={this.props.id ? this.props.id : "password"}
            type={this.state.type}
            required={true}
            name="password"
            readOnly={false}
            label={
              this.props.placeholder
                ? this.props.intl.formatMessage(
                    defaultMessages[this.props.placeholder]
                  )
                : this.props.intl.formatMessage(defaultMessages["password"])
            }
            autoComplete="new-password"
            value={this.state.password}
            onChange={this.onPasswordChange}
            onKeyUp={(event)=>this.verifyCapsLock(event)}
            onFocus={this.props.onFocus}
            hasWarning={this.state.loginError || this.state.isCapsLockActive}
            errorMessage={capsLockErrorMessage}
            inputClassName=""
            {...extraProps}
          />
          <span className="eye-container" onClick={this.showHide} role="button" aria-label="Show Password" style={{ cursor: 'pointer' }}>
            <img className="eye-image" alt="Show Password" src={`${window.location.origin}/web/assets/images/eye.svg`} />
          </span>
        </div>
      </div>
    );
  }
}

module.exports = ShowPassword;
